import { Footer } from "../First";

export function About(){

    return(

        <>
        
        <h1> About Page Bro </h1>
        <Footer />
        </>
    )
}
export default About; 